export const deviceNames = {
  alt1: 'Alternator 1',
  alt2: 'Alternator 2',
  bat1: 'Battery 1',
  bat2: 'Battery 2',
  regulator: 'Regulator',
}
